import hres6juLabels from 'assets/labels/hres6ju'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres6juLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        numclseq: faker.random.number().toString().substr(0, 1),
        desc_codcours: faker.lorem.words(),
        desc_codtparg: faker.lorem.word(),
        staappr: '',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remarkap: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: '',
        codplan: '',
        codcours: '',
        codtparg: '',
        dteyear: '',
        codappr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1Detail = {
      codinput: faker.lorem.word(),
      desc_codinput: faker.name.findName(),
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      codtparg: faker.random.number().toString().substr(0, 1),
      desc_codtparg: faker.lorem.word(),
      namcourse: faker.lorem.word(),
      codcours: 'A00002',
      desc_codcours: faker.lorem.word(),
      numclseq: faker.random.number().toString().substr(0, 1),
      dtetrst: moment().format('DD/MM/YYYY'),
      dtetren: moment().format('DD/MM/YYYY'),
      codinsts: faker.lorem.word(),
      desc_codinsts: faker.lorem.word(),
      codhotel: faker.lorem.word(),
      desc_codhotel: faker.lorem.words(),
      amtbudg: faker.commerce.price(),
      filename: faker.lorem.word(),
      path_filename: faker.lorem.word(),
      remark: faker.lorem.words()
    }

    return {
      tab1: mockTab1Detail
    }
  },
  popupTab1 () {
    let mockTab1PopupTable1Rows = []
    const mockTab1PopupTable1Total = 5
    for (var a = 1; a <= mockTab1PopupTable1Total; a++) {
      mockTab1PopupTable1Rows.push({
        id: a,
        dteyear: moment().format('YYYY'),
        dtemonth: moment().format('MMMM'),
        numclseq: faker.random.number().toString().substr(0, 1),
        codcours: faker.lorem.word(),
        desc_codcours: faker.lorem.words(),
        desc_codtparg: faker.lorem.words(),
        desc_codinsts: faker.lorem.words(),
        desc_codinst: faker.name.findName(),
        dtetrst: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        qtytrhur: faker.date.past().toString().substr(16, 5),
        coduser: '',
        codempid: '',
        codtparg: '',
        codinsts: '',
        codinst: ''
      })
    }
    let mockTab1PopupTable2Rows = []
    const mockTab1PopupTable2Total = 5
    for (var b = 1; b <= mockTab1PopupTable2Total; b++) {
      mockTab1PopupTable2Rows.push({
        id: b,
        codsco: faker.lorem.word(),
        desc_codsco: faker.lorem.word(),
        dtestartf: moment().format('DD/MM/YYYY'),
        dteendf: moment().format('DD/MM/YYYY'),
        dtecomm: moment().format('DD/MM/YYYY'),
        qtymth: faker.lorem.word(),
        amtexp: faker.random.number() + '.' + faker.random.number().toString().substr(0, 2)
      })
    }

    return {
      table1: {
        total: mockTab1PopupTable1Total,
        rows: mockTab1PopupTable1Rows
      },
      table2: {
        total: mockTab1PopupTable2Total,
        rows: mockTab1PopupTable2Rows
      }
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      codtparg: faker.lorem.word(),
      desc_codtparg: faker.lorem.word(),
      codcours: faker.lorem.word(),
      desc_codcours: faker.lorem.word(),
      numclseq: faker.lorem.word(),
      codplan: faker.lorem.word(),
      desc_codplan: faker.lorem.word(),
      dteyear: moment().format('YYYY'),
      dtetrst: moment().format('DD/MM/YYYY'),
      dtetren: moment().format('DD/MM/YYYY'),
      codinsts: faker.lorem.word(),
      desc_codinsts: faker.lorem.word(),
      codhotel: faker.lorem.word(),
      desc_codhotel: faker.lorem.word(),
      amtbudg: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
    return {
      tab1: mockTab1
    }
  },
  approve () {
    return {
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      codtparg: faker.lorem.word(),
      desc_codtparg: faker.lorem.word(),
      codcours: faker.lorem.word(),
      desc_codcours: faker.lorem.word(),
      numclseq: faker.random.number().toString().substr(0, 1),
      codplan: faker.lorem.word(),
      desc_codplan: faker.lorem.word(),
      dteyear: moment().format('YYYY'),
      dtetrst: moment().format('DD/MM/YYYY'),
      dtetren: moment().format('DD/MM/YYYY'),
      codinsts: faker.lorem.word(),
      desc_codinsts: faker.lorem.word(),
      codhotel: faker.lorem.word(),
      desc_codhotel: faker.lorem.word(),
      amtbudg: faker.commerce.price(),
      status: faker.lorem.words(),
      remark: faker.lorem.words(),
      staappr: ''
    }
  },
  training () {
    let mockTrainingTableRows = []
    const mockTrainingTableTotal = 5
    for (var c = 1; c <= mockTrainingTableTotal; c++) {
      mockTrainingTableRows.push({
        id: c,
        codcours: faker.lorem.word(),
        desc_codcours: faker.lorem.words(),
        dtemonth: moment().format('MMMM'),
        numclseq: faker.random.number().toString().substr(0, 1),
        dtetrst: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        codinst: faker.name.findName(),
        codhotel: faker.lorem.words()
      })
    }

    return {
      table: {
        total: mockTrainingTableTotal,
        rows: mockTrainingTableRows
      }
    }
  },
  dropdowns () {
    const mockCodtparg = {
      '1': 'ภายใน',
      '2': 'ภายนอก',
      '3': 'ไม่ระบุ'
    }
    const mockCodcours = {
      'A00001': 'ความรู้เบื้องต้นเกี่ยวกับการนำเสนองาน',
      'A00002': 'การใช้งานระบบ บัญชีการซื้อขาย',
      'B00001': 'เทคนิคการประชุมที่มีประสิทธิภาพ',
      'B00002': 'องค์กรที่เป็นเลิศกับการบริหารเชิงกลยุทธ์',
      'C00001': 'Customer Relations workshop Computer Training',
      'C00002': 'การใช้งานระบบ บัญชีการซื้อขาย',
      'CID001': 'สูงวัยอย่างไร',
      'CID002': 'ผู้จัดการมืออาชีพ',
      'D00001': 'Director Certification Program',
      'D00002': 'Directors Liabilities-Protecting Yourself in'
    }
    const mockNumclseq = {
      '1': '1',
      '2': '2',
      '3': '3'
    }
    const mockCodplan = {
      'A': 'แผนการฝึกอบรมประจำปี 2555',
      'B': 'โครงการการอบรมทางด้านบัญชี',
      'C': 'โครงการการอบรมทางด้านการผลิต',
      'D': 'โครงการการอบรมทางด้าน IT',
      'E': 'โครงการการอบรมทางด้านความรู้ทั่วไป',
      'F': 'โครงการการอบรมทางด้านการบริหาร',
      'G': 'โครงการการอบรมทางด้านช่างและการฝีมือ',
      'H': 'โครงการอบรมทางด้านบัญชี',
      'I': '(3 ป) เปิด ปรับ ปลง',
      'J': 'โครงการฝึกอบรมพนักงานเข้าใหม่'
    }

    const mockDtemonth = {
      '0': 'January',
      '1': 'February',
      '2': 'March',
      '3': 'April',
      '4': 'May',
      '5': 'June',
      '6': 'July',
      '7': 'August',
      '8': 'September',
      '9': 'October',
      '10': 'November',
      '11': 'December'
    }

    return {
      codtparg: {
        en: mockCodtparg,
        th: mockCodtparg
      },
      codcours: {
        en: mockCodcours,
        th: mockCodcours
      },
      numclseq: {
        en: mockNumclseq,
        th: mockNumclseq
      },
      codplan: {
        en: mockCodplan,
        th: mockCodplan
      },
      dtemonth: {
        en: mockDtemonth,
        th: mockDtemonth
      }
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  },
  numclseq () {
    return []
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6ju/mocker.js